import { useEffect } from "react";
import { useMap } from "react-leaflet";

export const normalizeCoordinates = (coords) => {
    if (!coords) return null;
    if (Array.isArray(coords) && coords.length >= 2) {
        const [lat, lon] = coords;
        if (typeof lat === "number" && typeof lon === "number" && !isNaN(lat) && !isNaN(lon)) {
            return [lat, lon];
        }
    }
    if (typeof coords === "object" && coords !== null) {
        const lat = coords.lat;
        const lon = coords.lon !== undefined ? coords.lon : coords.lng;
        if (typeof lat === "number" && typeof lon === "number" && !isNaN(lat) && !isNaN(lon)) {
            return [lat, lon];
        }
    }
    return null;
};

export const MapViewController = ({ targetCoordinates, zoom = 12 }) => {
    const map = useMap();

    useEffect(() => {
        if (map && typeof map.invalidateSize === "function") {
            map.invalidateSize();
            const timer = setTimeout(() => {
                map.invalidateSize();
            }, 200);
            return () => clearTimeout(timer);
        }
    }, [map]);

    useEffect(() => {
        const normalized = normalizeCoordinates(targetCoordinates);
        if (map && normalized && typeof map.flyTo === "function") {
            map.flyTo(normalized, zoom, {
                duration: 1.2,
                easeLinearity: 0.25,
            });
        }
    }, [targetCoordinates, zoom, map]);

    return null;
};
